export const { STRIPE_ACCOUNT, STRIPE_KEY } = window;
export const IS_STRIPE = Boolean(STRIPE_ACCOUNT && STRIPE_KEY);
